import type { GraphemeLessonPart } from "@-/dev.improve.haniverse.lib.level";
import { useLevels } from "@-/dev.improve.haniverse.routes.nav.app._lib.level";
import { findGraphemeLessonLevel, type Level } from "@-/dev.improve.haniverse.lib.level";

export function useLevel(slug: string): Level | undefined {
  const levels = useLevels();
  return levels.find((level) => level.slug === slug);
}

export function useFindLevelContainingCharacter(character: string): Level | undefined {
  const levels = useLevels();
  return levels.find((level) => level.characters.includes(character));
}

/**
 * The level a lesson of `grapheme` belongs to: its character level, or for a pronunciation-level
 * lesson (`part: "pronunciation"`) the level whose pronunciation level lists it.
 */
export function useFindGraphemeLessonLevel(lesson: {
  grapheme: string;
  part?: GraphemeLessonPart;
}): Level | undefined {
  return findGraphemeLessonLevel(useLevels(), lesson);
}
